import { g as getFocusableElements } from './getFocusableElements-BjFtn5aB.js';

/*
 * This utility function finds the first focusable element that is a child of the element that was
 * passed in as a parameter. It can be used to recreate the behavior if wrapping a `<label>`
 * around a label-able input that takes focus on click.
 */
function getFirstFocusableElement(element) {
  if (element) {
    const foundElements = getFocusableElements(element);
    if (foundElements[0]) {
      return foundElements[0];
    }
  }
  return false;
}

export { getFirstFocusableElement as g };
//# sourceMappingURL=getFirstFocusableElement-DegkMO1c.js.map
